import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'warning'];
  static values = {
    minimum: { type: Number, default: 0 },
  };

  connect() {
    this.checkValue();
  }

  checkValue() {
    if (!this.hasWarningTarget) return;

    const inputValue = this.parseTimeToHours(this.inputTargets[0].value + ':' + this.inputTargets[1].value);
    const minimum = this.minimumValue;

    this.warningTarget.classList.toggle('d-none', inputValue >= minimum);
  }

  parseTimeToHours(timeString) {
    if (!timeString) return 0;
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours + (minutes / 60);
  }
}
